// extracted by mini-css-extract-plugin
export var modalClose = "style-mod--modal-close--c230c";
export var modalCloseContainer = "style-mod--modal-close-container--6ae76";
export var modalCloseDesktop = "style-mod--modal-close-desktop--2b018";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--4e7f5";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--a3179";
export var modalCloseResponsive = "style-mod--modal-close-responsive--a1bc5";
export var variantCategoryIcon = "style-mod--variant-category-icon--7f9d7";
export var variantCategoryModule = "style-mod--variant-category-module--2fd8f";
export var variantCategorySection = "style-mod--variant-category-section--fd929";